//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageUploader from "../../components/ImageUploader";
import {submitData} from '../../api/delivery'

export default {
    name: "deliverData",
    components: {ImageUploader},
    data() {
        return {
            contractImage: {
                associateType: 'ContractImage',
                addAttrIds: [],
                delAttrIds: [],
            },
            identityImage: {
                associateType: 'IdentityImage',
                addAttrIds: [],
                delAttrIds: [],
            },
            deliveryRecordId: 0,
            saving: false,
            deliveryRecord: {}
        }
    },
    methods: {
        onSave() {
            if (this.contractImage.addAttrIds.length === 0) {
                this.$toast('请上传合同图片')
                return
            }
            if (this.contractImage.addAttrIds.length < 5) {
                this.$toast('请上传合同图片')
                return
            }
            // if (this.identityImage.addAttrIds.length === 0) {
            //     this.$toast('请上传身份证图片')
            //     return
            // }
            // if (this.identityImage.addAttrIds.length < 2) {
            //     this.$toast('请上传身份证图片')
            //     return
            // }
            const page = {
                recordId: this.deliveryRecordId,
                contractImage: this.contractImage,
                // identityImage: this.identityImage
            }
            this.saving = true;
            submitData(page).then(res => {
                this.$toast.success('提交成功')
                this.$router.replace({path: '/my-appoint'})
            }).finally(() => {
                this.saving = false;
            })
        },
        getRecordById() {
            const vm = this;
            abp.ajax.get('/api/services/app/DeliveryRecord/GetDeliveryRecordById?id=' + this.deliveryRecordId).then(res => {
                vm.deliveryRecord = {}
                vm.deliveryRecord = res.data.result;
            });
        },
    },
    created() {
        this.deliveryRecordId = parseInt(this.$route.params.id)
        this.getRecordById();
    }
}
